import * as yup from 'yup';
import { useCallback } from 'react';
import { FORM_ERROR, setIn } from 'final-form';
export type ValidationMethod<T> = (values: any) => {} | Record<keyof T, any>;

export type ValidationOptions = {
	abortEarly?: boolean;
};

export function useSchemaValidation<T>(
	schema: yup.Schema<T>,
	options?: ValidationOptions
): [yup.Schema<T>, ValidationMethod<yup.InferType<yup.Schema<T>>>] {
	//@ts-ignore
	const validate: ValidationMethod<yup.InferType<yup.Schema<T>>> = useCallback(
		//@ts-ignore
		(formValues: any) => {
			try {
				schema.validateSync(formValues, { abortEarly: options?.abortEarly || false });
				return {};
			} catch (error) {
				if (error instanceof yup.ValidationError) {
					if (error.inner?.length) {
						return error.inner.reduce(
							(errors, validationError) => setIn(errors, validationError.path || FORM_ERROR, validationError.message),
							{}
						);
					}

					return setIn({}, error.path || FORM_ERROR, error.message);
				}

				return error;
			}
		},
		[schema]
	);

	return [schema, validate];
}
